import Popup from "../../../../../../common/components/popup";
import ReconciliationsItems from "./reconciliation-items";

export const ReconciliationItemsPopup = ({ 
  selectedReconciliation,
  closeModal,
  
}: any) => {

    return (
      <>
        <Popup onClose={closeModal}>
          <ReconciliationsItems
            selectedReconciliation={selectedReconciliation}
          />
        </Popup>
      </>
    )
  }